import { StyledSelect } from '../select.style';

interface LmiDocumentTypeSelectProps {
  onChange: (value: string, e: any) => void;
  value: number | string;
  disabled: boolean;
  options: {
    disabled?: boolean;
    selected?: boolean;
    text: string;
    value?: number | string;
  }[];
}
export const LmiDocumentTypeSelect = ({
  onChange,
  value,
  options,
  disabled,
}: LmiDocumentTypeSelectProps) => {
  return (
    <StyledSelect
      disabled={disabled}
      id="lmi-document-type-select"
      label="Document type"
      withEmptyPlaceholder
      loading={false}
      minHeight="auto"
      name="lmiDocumentType"
      onChange={onChange}
      options={options}
      value={value}
    />
  );
};
